// extracted by mini-css-extract-plugin
export default {"image":"Login_image__HSc4S","logo":"Login_logo__6UmZd","form":"Login_form__UTWnZ"};